import React from "react";

import ParallaxImage from "../ParallaxImage";
import { ReactLenis } from "@studio-freight/react-lenis";
import "../../css/SelectionBg.css";
import InteriorDesignResidentialSelectionComponent from "../InteriorDesignComponents/InteriorDesignResidentialSelection";
import LuxeSelection from "../Selection2/LuxeSelection";
import BeysuSelection from "../Selection2/BeysuSelection";
import CommercialSelectionComponent from "./CommercialSelectionComponent";
import MagellanSelection from "../Selection2/MagellanSelection";
import MagellanShow from "./commercialimagesshow/MagellanShow";
import RaddissonSelection from "../Selection2/radissonSelection";
import RadissonShow from "./commercialimagesshow/RadissonShow";
import UnodcSelection from "../Selection2/unodcSelection";
import RiyadhSelection from "../Selection2/RiyadhSelection";
import SadkoSelection from "../Selection2/SadkoSelection";
import WoodSelection from "../Selection2/WoodSelection";
import WoodShow from "./commercialimagesshow/WoodShow";
import WoodShow2 from "./commercialimagesshow/WoodShow2";

export default function WoodAterlierComponent() {
  return (
    <ReactLenis root>
      <div className="app1">
        <section className="hero">
          <div className="img">
            <ParallaxImage
              src="../../Images/CommercialImages/8-WoodAtelierforChildren/COMPLETED/2.jpeg"
              alt=""
            />
          </div>

          <div className="nav">
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                paddingTop: "200px",
              }}
            >
              <p className="p5">Wood Atelier for Children</p>
              {/* <p>COMMERCIAL INTERIOR DESIGN</p>
              <p>EXTERIOR DESIGN</p> */}
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  paddingLeft: "10px",
                  color: "#e7e7e7",
                  textTransform: "uppercase",
                  fontSize: "20px",
                }}
              >
                <span>
                  role in project: architectural drawings, 3d visualization,
                  <br />
                  manufacturing of furnitures and fixtures, Fit-Out, project
                  execution
                </span>
                <span>project duration: 3 months</span>
                <span>year of completion: 2022</span>
                <span>project location: Baku, Azerbaijan</span>
              </div>
            </div>
          </div>
        </section>

        <section className="projects">
          <div className="img">
            <ParallaxImage
             src="../../Images/CommercialImages/8-WoodAtelierforChildren/COMPLETED/3.jpg"
              alt=""
            />
          </div>

          {/* <div className="projects-brief">
              <p
                style={{
                    color:"black",
                    fontSize:"30px"
                }}
              >
              This modern living space and bedroom are designed to inspire with its elegant lines, warm tones, and luxurious finishes, creating an inviting ambiance for both relaxation and entertaining.
              </p>
            </div> */}

          <div className="col projects-cover">
            <div
              className="img"
              style={{
                marginTop: "1000px",
                zIndex: "9999",
              }}
            >
              <ParallaxImage
                  src="../../Images/CommercialImages/8-WoodAtelierforChildren/COMPLETED/5.jpg"
                alt=""
              />
            </div>
          </div>

          <div className="col projects-list">
            <div className="project">
              <h1
                style={{
                  paddingRight: "550px",
                  textAlign: "right",
                  textTransform: "uppercase",
                }}
              >
                
                <br />
                
              </h1>
            </div>
            <div className="project">
              <h1
                style={{
                  paddingRight: "550px",
                  textAlign: "right",
                  textTransform: "uppercase",
                }}
              >
                
                <br />
              
              </h1>
            </div>
            <div className="project">
              <h1
                style={{
                  paddingRight: "550px",
                  textAlign: "right",
                  textTransform: "uppercase",
                }}
              >
             
                <br />
            
              </h1>
            </div>
          </div>
        </section>

        <section className="projects">
          <div className="img">
            <ParallaxImage src="../../Images/Untitled.png" alt="" />
          </div>

          <div className="projects-brief">
            <p
              style={{
                color: "#dbccc0",

                paddingLeft: "350px",
                width: "800px",
                fontSize: "35px",
                textAlign: "left",
              }}
            >
              "Fostering creativity and hands-on learning."
            </p>
          </div>

          <div className="col projects-cover">
            <div className="img" style={{}}>
              <ParallaxImage
                    src="../../Images/CommercialImages/8-WoodAtelierforChildren/COMPLETED/5.jpg"
                alt=""
              />
            </div>
          </div>

          <div
            className="col projects-list"
            style={{
              opacity: "0",
            }}
          >
            <div className="project">
              <h1>A Perfect Blend</h1>
            </div>
            <div className="project">
              <h1>Blend of Style and Comfort</h1>
            </div>
            <div className="project">
              <h1>Comfort</h1>
            </div>
            <div className="project">
              <h1>2024</h1>
            </div>
          </div>
        </section>

        <section className="about">
          <div className="col intro">
            <p>ABOUT</p>
            <p
              style={{
                width: "450px",

              }}
            >
              This Wood Atelier for children encourages creativity and hands-on
              learning. With its natural wood furniture and functional layout,
              the atelier offers an inviting environment for young minds to
              explore woodworking, engineering, and design. Our team handled
              both the design and production, ensuring each element promotes
              safety, accessibility, and inspiration for the children. The
              workspace is equipped with essential tools and materials,
              fostering a blend of education and practical skills in a setting
              that feels both professional and child friendly.
              
            </p>
          </div>
          <div className="col portrait">
            <div className="portrait-container">
              <div className="img">
                <ParallaxImage
                     src="../../Images/CommercialImages/8-WoodAtelierforChildren/COMPLETED/7.jpeg"
                  alt=""
                />
              </div>
            </div>
          </div>
        </section>

        <section className="banner">
          <WoodSelection />
        </section>

        <section className="banner">
          <div className="img">
            <ParallaxImage
            src="../../Images/CommercialImages/8-WoodAtelierforChildren/RENDER/3b.jpg"
              alt=""
            />
          </div>

          {/* <div className="banner-copy">
              <p
              
              >Location:</p>
              <h1
                style={{
                    color:"#1a1a1a"
                }}
              >Yenimahalle, </h1>
             <h1
               style={{
                color:"#1a1a1a"
            }}
             >Ankara-TURKIYE</h1>
            
            </div> */}
        </section>

        {/* <section className="footer1">
          <div className="col">
            <p>Instagram</p>

            <div className="footer-links">
              <p>Luxe Residance</p>
              <h1
                style={{
                  fontSize: "40px",
                }}
              >
                "A Perfect Blend
              </h1>
              <h1> of Style and Comfort."</h1>
              <h1
                style={{
                  fontSize: "40px",
                }}
              >
                A2Z Design & Build
              </h1>
            </div>
          </div>

       
          <div className="col">
              <p>
                Join the newsletter <br />
                <button>Subscribe</button>
              </p>
  
              <div className="shop">
                <div className="img">
                  <ParallaxImage src="../Images/landingpageimage/image8.jpg" alt="" />
                </div>
              </div>
  
              <p>Spotify / Apple Music / Youtube</p>
            </div>
        </section> */}

        <section className="footer2">
          <div className="col2">
            <div className="footer-links">
              <h1
                style={{
                  textAlign: "center",
                  fontSize: "40px",
                }}
              >
                “Wood Atelier: A Creative Learning Space for Children”
              </h1>
              <p>A2Z Design Studio</p>
            </div>
          </div>

          {/* <div className="col">
              <p>
                Join the newsletter <br />
                <button>Subscribe</button>
              </p>
  
              <div className="shop">
                <div className="img">
                  <ParallaxImage src="../Images/landingpageimage/image8.jpg" alt="" />
                </div>
              </div>
  
              <p>Spotify / Apple Music / Youtube</p>
            </div> */}
        </section>
        <div>
        <h1
            style={{
              marginBottom:"20px",
              textAlign:"center",
              textTransform:"uppercase",
              fontSize:"35px",
              fontWeight:"100"
            }}
          >
          3d visualizations
          </h1>
        <WoodShow/>
        </div>
        <h1
            style={{
              marginBottom:"20px",
              textAlign:"center",
              textTransform:"uppercase",
              fontSize:"35px",
              fontWeight:"100",
              marginTop:"50px"
            }}
          >
          completed projects
          </h1>
        <div>
        <WoodShow2/>
        </div>
     
        <CommercialSelectionComponent />
      </div>
    </ReactLenis>
  );
}
